import store from '@experience/store/index';
import router from '@experience/router/experience.router';
import i18n from '@experience/static/i18n/index';

export default {
    store,
    router,
    i18n
};
